import React from 'react';
import { Flex } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { PolicyProvider } from '@Policy/store';
import { getExchangeTemplateConfig } from '@Policy/TemplateConfig/cfg.exchange';
import { TreeNode } from '@Components/Tree/type';
import { RoleTarget } from '@Types/administrator';
import { LocalAccountTargets } from '../../../../RoleTargets/LocalAccoutTargets';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';

const EditRoleAssigment = ({
  roleTargets,
  currentOrgId,
  setCheckTargets,
}: {
  roleTargets: RoleTarget[] | null;
  currentOrgId: string;
  setCheckTargets: (checkedKeys: RoleTarget[]) => void;
}) => {
  const { t } = useTranslation();
  const [target, setTarget] = React.useState<any>(null);
  const configData: any = {};
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const defaultTemplate = getExchangeTemplateConfig(
    t,
    selectedOrgGlobalSetting,
    ''
  );
  React.useEffect(() => {
    if (roleTargets !== null) {
      if (roleTargets.length > 0) {
        const targets: TreeNode[] = roleTargets.map((item: RoleTarget) => ({
          title: item.displayName,
          key: item.target,
          firstName: null,
          lastName: null,
        }));
        console.log('targets', targets);
        defaultTemplate.policyTarget = {
          targets,
          capacity: 'normal',
          targetGroups: [],
          targetType: 'user',
        };
        setTarget(
          <PolicyProvider
            template={defaultTemplate}
            config={configData}
            key={currentOrgId}
            orgId={currentOrgId}
          >
            <Flex mt="23px" alignItems="flex-start">
              <LocalAccountTargets setCheckTargets={setCheckTargets} />
            </Flex>
          </PolicyProvider>
        );
      } else {
        setTarget(
          <PolicyProvider
            template={defaultTemplate}
            config={configData}
            key={currentOrgId}
            orgId={currentOrgId}
          >
            <Flex mt="23px" alignItems="flex-start">
              <LocalAccountTargets setCheckTargets={setCheckTargets} />
            </Flex>
          </PolicyProvider>
        );
      }
    }
  }, [currentOrgId, roleTargets]);

  return <>{target}</>;
};

export default React.memo(EditRoleAssigment);
